import './styles/index.scss';
import Hero from './components/hero';
import Footer from './components/footer';
import About from './components/about';
import Contact from './components/contact';
import View from './components/Layouts/visor';
import firebase, {FirebaseContext} from './firebase/index';
import {CircleArrow as ScrollUpButton} from "react-scroll-up-button";
function App() {
  return (
    <FirebaseContext.Provider
      value={{firebase}}
    >
    <div className="App ">
  
      <Hero/>
        <section className="content">
      
            <section id="about">
                <About/>
            </section>
            <section id="proyects">
              <View/>
            </section>
            
             
        </section>
        <section id="contact">
                <Contact/>
            </section>
        <Footer/>
          
    </div>
     <ScrollUpButton
          EasingType="easeOutSine"
          //EasingType="easeOutBounce"
          ShowAtPosition={1401}
          AnimationDuration={2500}
        />
    </FirebaseContext.Provider>
  );
}

export default App;
